var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHmGroupWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 102",
    style: {
      enableBackground: "new 0 0 496 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.36,76.77 2.56,76.77 2.56,4.77 11.36,4.77 11.36,36.07 48.76,36.07 48.76,4.77 57.66,4.77  57.66,76.77 48.76,76.77 48.76,43.77 11.36,43.77  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.65,18.57c0-8.8,6.8-15.3,16.4-15.3c9.7,0,16.5,6.7,16.5,15.3c0,6.7-4.2,12.6-13.4,18.4 c5.8,6.9,11.5,13.8,17.3,20.6c2.3-4.9,3.5-10.6,3.8-17h8.3c-0.3,8.8-2.5,16.6-6.7,23.4l10.8,12.8h-10.2c-1.9-2.1-3.7-4.4-5.6-6.6 c-5.7,5.5-12.7,8.1-20.8,8.1c-14.8,0-24.1-8.4-24.1-21c0-8.2,4.8-15,16-21.6C76.66,28.57,74.65,23.47,74.65,18.57 M87.56,41.17 c-9.7,6.1-12.1,10.3-12.1,16.1c0,8.3,6.1,13.5,15.6,13.5c6.5,0,11.8-2.2,15.9-6.4L87.56,41.17z M99.26,18.57c0-4.8-2.9-7.8-8.1-7.8 c-5.1,0-8.2,3.1-8.2,7.8c0,3.5,1.7,7,6.6,12.9C96.36,27.07,99.26,23.87,99.26,18.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.96,76.77h-8.4l-21.1-56.1h-0.2v56.1h-8.3v-72h10.9l23.1,61.6c7.8-20.5,15.5-41.1,23.2-61.6h10.5v72h-8.4 v-56.1h-0.1C188.16,39.37,181.06,58.07,173.96,76.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.36,48.37h-21.2v-7.6h30.4v36h-6.3l-2-9.3c-5.7,7.8-13.7,10.8-22.1,10.8c-21.9,0-33.8-15.8-33.8-37.5 c0-20.7,11.8-37.5,33.8-37.5c14.6,0,26.5,7.9,29.2,22.3h-9.2c-2.3-9.4-10.2-14.4-20-14.4c-17.2,0-24.7,14.5-24.7,29.6 c0,16.5,7.4,29.7,24.7,29.7C275.16,70.47,285.56,61.97,286.36,48.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.65,26.47h8.2v7c2.6-5.6,7.8-8.5,15-8.5c1.7,0,3.2,0.1,4.6,0.3v7.4c-1.6-0.2-3.1-0.3-4.6-0.3 c-9.9,0-15,5.1-15,15v29.4h-8.2V26.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.05,51.67c0,16.8-11.2,26.6-24.9,26.6c-13.8,0-24.8-9.9-24.8-26.6c0-16.6,11-26.7,24.8-26.7 C373.75,24.97,385.05,34.77,385.05,51.67 M376.55,51.67c0-12.8-7.1-19.2-16.4-19.2c-9.5,0-16.4,6.4-16.4,19.2 c0,12.7,6.9,19.1,16.4,19.1C369.55,70.77,376.55,64.37,376.55,51.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.45,76.77v-5.9c-3.7,4.9-9,7.4-16.1,7.4c-11.8,0-17.7-6.8-17.7-20.3v-31.5h8.2v31.1 c0,9.2,3.4,13.4,11.2,13.4c8.3,0,14.4-5.4,14.4-14.6v-29.9h8.2v50.3H426.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.65,32.67c3.8-5.1,9.2-7.7,16.5-7.7c13.9,0,23.4,10.8,23.4,26.7c0,15.8-9.3,26.6-23.4,26.6 c-7.3,0-12.8-2.5-16.5-7.7v27h-8.2V26.47h8.2V32.67z M469.55,70.97c9.6,0,15.5-6.9,15.5-19.4c0-12.4-6-19.3-15.5-19.3 c-10.3,0-15.9,6.3-15.9,19.4C453.65,64.37,459.25,70.97,469.55,70.97"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmGroupWhiteLogo);
export default __webpack_public_path__ + "static/media/h&m_group_white_logo.6930ac11396eca69a6f999386bfe4872.svg";
export { ForwardRef as ReactComponent };